import React from 'react';
import {Box,Typography, Button} from '@mui/material';

import Herobanner from '../assets/images/banner2.jpg'

const HeroBanner = () => {
  return (
    <Box
    sx={{
      mt:{lg:'212px', xs:'70px'},
      ml:{sm:'50px'}
    }}
    position="relative" p="20px"
    >
        <Typography color="#FF2625" fontWeight="600" fontSize="26px">
          Fitness Club
        </Typography>
          <Typography fontWeight="700"
          sx={{fontSize:{lg:'44px', xs:'40px'}}}
          mb="25px"
          mt="30px"
          >
              Sweat, Smile <br /> and Stay Health
          </Typography>
          <Typography fontSize="22px" LineHeight="35px" mb={6}>
           Check out the most effective exercises.
      </Typography>

      <Button variant="contained" color="error" href='#exercises'
      sx={{backgroundColor:'#ff2625', padding:"10px"}}
      >
        Explore Exercises
      </Button>
      <Typography
      fontWeight={600}
      color="#ff2625"
      sx={{
        opacity:0.1,
        display:{lg:'block', xs:'none'}
      }}
      fontSize="200px"

      >Exercise</Typography>
      <img src={Herobanner} alt='banner' className='hero-banner-img'/>
    </Box>
  )
}

export default HeroBanner